// removed by extract-text-webpack-plugin
module.exports = {"root":"order-success--root--3c9VZFsQ","title":"order-success--title--3c44F06G","subtitle":"order-success--subtitle--3HQjsIej","actions":"order-success--actions--3rdBzpX6"};


//////////////////
// WEBPACK FOOTER
// ./components/order-success/styles.css
// module id = ./components/order-success/styles.css
// module chunks = 0